export const onOpenEmail = row => {
	const win = window.open(`mailto:${row.email}`)
	win.focus()
	setTimeout(() => {
		win.close()
	}, 100)
}
